import React from 'react';

// Final mark from Claude Design (project "Assaggioo logo concepts", concept 1a):
// two bordeaux legs forming an "A" with a rounded amber crossbar.
export default function AssaggiooLogo({
  size = 40,
  variant = 'default',
  badge = true,
}: {
  size?: number;
  variant?: 'default' | 'mono' | 'white';
  badge?: boolean;
}) {
  const legColor = variant === 'white' ? '#FFFFFF' : variant === 'mono' ? '#151A13' : '#6B2737';
  const barColor = variant === 'white' ? '#FFFFFF' : variant === 'mono' ? '#151A13' : '#F59E0B';
  const markSize = badge ? Math.round(size * 0.72) : size;

  const mark = (
    <svg width={markSize} height={markSize} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <line x1="50" y1="12" x2="15" y2="90" stroke={legColor} strokeWidth="15" strokeLinecap="round" />
      <line x1="50" y1="12" x2="85" y2="90" stroke={legColor} strokeWidth="15" strokeLinecap="round" />
      <rect x="29" y="57" width="42" height="13" rx="6.5" fill={barColor} />
    </svg>
  );

  if (!badge) return mark;

  return (
    <div style={{
      width: size, height: size, borderRadius: Math.round(size * 0.22), flexShrink: 0,
      background: variant === 'white' ? 'rgba(255,255,255,0.14)' : '#F6F8F5',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      {mark}
    </div>
  );
}
